import type { AxiosInstance } from 'axios';
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from './client';

export type { RequestConfig, ResponseConfig, ResponseErrorConfig };

export let globalInstance: AxiosInstance;

export const initialiseGlobalAxiosClient = (newInstance: AxiosInstance): AxiosInstance => {
  globalInstance = newInstance;

  return globalInstance;
};

export const customInstance = <TData, TError = unknown, TVariables = unknown>(
  config: RequestConfig<TVariables>
): Promise<ResponseConfig<TData>> => {
  return globalInstance.request<TVariables, ResponseConfig<TData>>(config).catch((e: ResponseErrorConfig<TError>) => {
    throw e;
  });
};

export default customInstance;
